export const ExceptionsMap = {
  REFERRAL_CODE_ALREADY_USED: `Referral code already used!`,
  INVALID_REFERRAL_CODE: `Invalid Referral code!`,
};
